import plusIcon from "../assets/svg/plus-table.svg";

import { apiDeletePersons, apiGetPersons, apiGetPersonsExcel } from "../api/personApi";
import { apiDeleteManufactureFormulas, apiManufactureFormulas } from "api/manufactureFormulaApi";
import ManufactureFormulaSwitch from "components/manufactureOrders/ManufactureFormulaSwitch";

const defaultManufactureFormulasColumns = [
  {
    name: "کد",
    key: "accountingCode",
    // filterParams: {
    //   column: "accountingCode",
    //   columnType: "string",
    // },
  },
  {
    name: "عنوان فرمول تولید",
    key: "title",
  },
  {
    name: "کد محصول",
    key: "accountingCode", // get value accountingCode
    getValue: (item) => {
      return item?.Product?.accountingCode ?? "-";
    },
  },
  {
    name: "نام محصول",
    key: "Product", // getValue title
    getValue: (item) => {
      return item?.Product?.title ?? "-";
    },
  },
  {
    name: "واحد اندازه گیری",
    key: "unit",
    getValue: (item) => {
      return item?.Product?.unit ?? "-";
    },
  },
  {
    name: "وضعیت",
    key: "active",
    Component: ManufactureFormulaSwitch,
  },
];

export const manufactureFormulasIndexData = [
  {
    key: "customer",
    label: "همه",
    pluralLabel: "همه",
    title: "همه",
    pageTitle: "فرمول های تولید",
    pageDescription: "نمایش کالا و خدمات کسب و کار",
    tableColumns: defaultManufactureFormulasColumns,
    disableDateFilter: true,
    actions: {
      add: {
        title: "افزودن",
        icon: plusIcon,
        url: "/manufacture/formulas/add",
      },
      edit: {},
      fetch: apiManufactureFormulas,
      delete: apiDeleteManufactureFormulas,
      // excel: {
      //   export: apiGetPersonsExcel,
      //   import: apiGetPersonsExcel,
      // },
      // archive: {
      //   model: "person",
      // },
    },
  },
];
